export default "__VITE_ASSET__DXbr0y$0__"